import { ThemeEditorPane } from '../components/admin-themes/theme-content';
import { ThemeList } from '../components/admin-themes/theme-list';
import { ContentPage } from '../components/content-page';
import { ThemesDataProvider } from '../providers/theme-management-provider';
import { useLocation } from 'react-router-dom';

export default function AdminThemesPage() {
    const { search } = useLocation();
    return (
        <ThemesDataProvider>
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: '0'/*, backgroundColor: 'blue'*/ }}>
                <ContentPage
                    pageId="themes"
                    pageTitle="Theme management"
                    leftPanelTitle="Themes"
                    rightPanelTitle="Selected theme details"
                    mobileTabs
                    mobileBackLabel="Back to themes"
                    mobileRightPanelTitle="Details"
                    initialMobilePanel={new URLSearchParams(search).has('theme') ? 'right' : 'left'}
                    leftContent={<ThemeList />}
                    rightContent={<ThemeEditorPane />}
                    leftContentPercent={20}
                />
            </div>
        </ThemesDataProvider>
        );
}
